import React, { FC } from 'react';
import s from './index.module.scss';
import safeCard from './img/SafetyCard.png';

import styled from 'styled-components';
import { useT } from '@hooks';

const Container = styled.div`
	margin: 20px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 15px;
`;

const SafetyAssurance: FC = () => {
	const { T } = useT();
	return (
		<Container>
			<div className={s.imgCircle}>
				<img src={safeCard} alt='img' />
			</div>
			<div className={s.content}>
				<div className={s.content__title}>{T('safety_assurance')}</div>
				<div className={s.content__text}>{T('safety_assurance_text')}</div>
			</div>
		</Container>
	);
};

export default SafetyAssurance;
